
export default function ComboTour() {
  const tours = [
    {
      name: 'LA - Las Vegas - Grand Canyon',
      duration: '3-4 ngày',
      highlights: 'Thành phố ánh sáng, hẻm núi kỳ vĩ',
      icon: 'ri-landscape-line'
    },
    {
      name: 'San Francisco - Yosemite - Napa Valley',
      duration: '3-5 ngày',
      highlights: 'Cầu Vàng, công viên quốc gia, vùng rượu vang',
      icon: 'ri-goblet-line'
    },
    {
      name: 'LA - San Diego - Disneyland',
      duration: '2-3 ngày',
      highlights: 'Bãi biển, công viên giải trí nổi tiếng',
      icon: 'ri-ship-line'
    },
    {
      name: 'Utah National Parks Tour',
      duration: '4-6 ngày',
      highlights: 'Zion, Bryce Canyon, Arches, Monument Valley',
      icon: 'ri-mountain-line'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-red-600 to-orange-500 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6" style={{ textShadow: '0 3px 8px rgba(0,0,0,0.5)' }}>
            Các Tuyến Tour Phổ Biến
          </h2>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-bold" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
            Chúng tôi có kinh nghiệm phục vụ hàng trăm đoàn trên các tuyến này
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {tours.map((tour, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 border border-white/20"
            >
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
                <i className={`${tour.icon} text-4xl`}></i>
              </div>
              <h3 className="text-2xl font-extrabold mb-3" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
                {tour.name}
              </h3>
              <div className="space-y-3">
                <p className="flex items-center text-lg font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                  <i className="ri-time-line mr-2 text-xl"></i>
                  {tour.duration}
                </p>
                <p className="text-lg leading-relaxed font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                  {tour.highlights}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-xl md:text-2xl font-bold mb-6" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
            Có thể tùy chỉnh lịch trình theo yêu cầu của đối tác
          </p>
          <button
            onClick={() => {
              const formSection = document.getElementById('contact-form');
              if (formSection) {
                formSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="whitespace-nowrap bg-white text-red-600 hover:bg-gray-100 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-extrabold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            <i className="ri-route-line mr-2 text-lg sm:text-xl"></i>
            Tư vấn lịch trình
          </button>
        </div>
      </div>
    </section>
  );
}
